import { render, staticRenderFns } from "./PartInfo.vue?vue&type=template&id=31017f52&"
import script from "./PartInfo.vue?vue&type=script&lang=js&"
export * from "./PartInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports